import { toBlob } from "html-to-image";

export const CARD_SIZE = 1080;

export function cardFilename(displayName) {
  const slug = (displayName || "founder").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") || "founder";
  return `minuteswap-impact-${slug}-${new Date().toISOString().slice(0, 10)}.png`;
}

const FONT_CSS_URLS = [
  "https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&family=IBM+Plex+Mono:wght@400;500;600&display=swap",
  "https://api.fontshare.com/v2/css?f[]=cabinet-grotesk@700,800,900&display=swap",
];
let fontCssPromise = null;

async function toDataUrl(url) {
  const res = await fetch(url, { mode: "cors" });
  const blob = await res.blob();
  return new Promise((resolve) => { const r = new FileReader(); r.onload = () => resolve(r.result); r.readAsDataURL(blob); });
}

// Build self-contained @font-face CSS once (fonts inlined as data URLs) so the export never touches cross-origin stylesheets.
function fontEmbedCSS() {
  if (!fontCssPromise) {
    fontCssPromise = (async () => {
      const chunks = await Promise.all(FONT_CSS_URLS.map(async (cssUrl) => {
        try {
          let css = await (await fetch(cssUrl, { mode: "cors" })).text();
          const urls = [...new Set([...css.matchAll(/url\((["']?)([^)"']+)\1\)/g)].map((m) => m[2]))];
          const inlined = await Promise.all(urls.map(async (u) => [u, await toDataUrl(u).catch(() => null)]));
          inlined.forEach(([u, data]) => { if (data) css = css.split(u).join(data); });
          return css;
        } catch { return ""; }
      }));
      return chunks.join("\n");
    })();
  }
  return fontCssPromise;
}

export async function renderCardBlob(node) {
  if (document.fonts?.ready) await document.fonts.ready;
  const opts = { width: CARD_SIZE, height: CARD_SIZE, pixelRatio: 1, cacheBust: true, backgroundColor: "#0B0C0E" };
  try {
    return await toBlob(node, { ...opts, fontEmbedCSS: await fontEmbedCSS() });
  } catch {
    return await toBlob(node, { ...opts, skipFonts: true });
  }
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.rel = "noopener";
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}

export function canShareFiles() {
  if (typeof navigator === "undefined" || !navigator.share || !navigator.canShare) return false;
  try {
    const probe = new File([new Blob(["x"], { type: "image/png" })], "probe.png", { type: "image/png" });
    return navigator.canShare({ files: [probe] });
  } catch { return false; }
}

export async function shareBlob(blob, filename, { title, text, url }) {
  const file = new File([blob], filename, { type: "image/png" });
  const payload = { files: [file], title, text: url ? `${text} ${url}` : text };
  await navigator.share(payload);
}
